export const biddingConfig = {
    maxBiddingLimit: 100000,
    biddingIncrement: 100,
    depositPercentage: 0.1,
    purchaseLimitThresholds: [
      { vehicles: 1, minBidding: 3500 },
      { vehicles: 2, minBidding: 15000 },
      { vehicles: 3, minBidding: 20000 },
      { vehicles: 4, minBidding: 25000 },
      { vehicles: 5, minBidding: 30000 },
      { vehicles: 6, minBidding: 35000 },
      { vehicles: 7, minBidding: 40000 },
      { vehicles: 8, minBidding: 45000 },
      { vehicles: 9, minBidding: 50000 },
      { vehicles: 10, minBidding: 55000 },
      { vehicles: 11, minBidding: 60000 },
      { vehicles: 12, minBidding: 65000 },
      { vehicles: 13, minBidding: 70000 },
      { vehicles: 14, minBidding: 75000 },
      { vehicles: 15, minBidding: 80000 },
      { vehicles: 16, minBidding: 85000 },
      { vehicles: 17, minBidding: 90000 },
      { vehicles: 18, minBidding: 95000 },
      { vehicles: 19, minBidding: 100000 },
    ]
  };
  